import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useFeatureSwitch } from '@xing-com/hub';

import { ARMSTRONG_V1 } from '../../config/feature-switches';

import * as Styled from './manage-updates.styles';

export const ManageUpdates: FC = () => {
  const { pageContext } = usePageContext();

  const isArmstrong = useFeatureSwitch(ARMSTRONG_V1, false);

  return (
    <Styled.Button
      $isArmstrong={!!isArmstrong}
      variant="secondary"
      size="small"
      to={`${pageContext.basePath}/${pageContext.pageSlug}/news`}
    >
      <FormattedMessage id="EP_EDITBAR_MANAGE_UPDATES" />
    </Styled.Button>
  );
};
